const getApiBaseUrl = () => {
  if (typeof window === "undefined") {
    return "https://www.datacook.de";
  }

  const { hostname, origin } = window.location;

  if (hostname === "www.datacook.de" || hostname === "datacook.de") {
    return origin;
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:8000";
  }

  return `http://${hostname}:8000`;
};

export async function submitContactForm(formData) {
  const payload = {
    firstName: formData.get("firstName")?.toString().trim() || "",
    lastName: formData.get("lastName")?.toString().trim() || "",
    position: formData.get("position")?.toString().trim() || "",
    companyName: formData.get("companyName")?.toString().trim() || "",
    email: formData.get("email")?.toString().trim() || "",
    phoneNumber: formData.get("phoneNumber")?.toString().trim() || "",
    topic: formData.get("topic")?.toString().trim() || "",
    message: formData.get("message")?.toString().trim() || "",
  };

  const response = await fetch(`${getApiBaseUrl()}/api/submit-form/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const contentType = response.headers.get("content-type") || "";
  const responseBody = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const detail =
      typeof responseBody === "string"
        ? responseBody
        : responseBody.detail || responseBody.message;
    throw new Error(detail || `Request failed with status ${response.status}`);
  }

  return responseBody;
}
